import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import PassesSwitchField from '../passes-new/PassesSwitchField';

const PassesBatchNavigationSwitchField = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isBatchesPage = location.pathname.includes('/passes/batches');

  const handleToggle = (value: boolean): void => {
    if (value) {
      navigate('/passes');
    } else {
      navigate('/passes/batches');
    }
  };

  return (
    <Box pl="0" mb={6}>
      <PassesSwitchField
        value={!isBatchesPage}
        onChange={handleToggle}
        leftLabel="Passes"
        rightLabel="Bulk operations"
      />
    </Box>
  );
};

export default PassesBatchNavigationSwitchField;
